import CtaTextOnlyBoxes from './ctaTextOnlyBoxes';

export default CtaTextOnlyBoxes;
